import dayjs from '../../../../utils/dateUtils';

const SESSION_DATE_PATTERN = /(\d{4}-\d{2}-\d{2}T[\d:.]+)/;

export function getSessionCreatedOn(session) {
  if (!session) {
    return null;
  }

  const match = session.name?.match(SESSION_DATE_PATTERN);

  return match?.[1] ?? null;
}

export function getSessionUsername(session) {
  if (!session) {
    return null;
  }

  const username = session.name?.split(' ')[0] ?? null;
  if (!username || username.match(SESSION_DATE_PATTERN)) {
    return null;
  }
  return username;
}

export function formatSessionDate(date, locale) {
  if (!date || !dayjs(date).isValid()) {
    return null;
  }

  return dayjs(date).locale(locale).format('MMM D, HH:mm');
}

export function getSessionData(session, locale) {
  const email = getSessionUsername(session);
  const rawDate = getSessionCreatedOn(session);
  const date = formatSessionDate(rawDate, locale);

  return {
    email: email ?? null,
    date: date ?? null,
  };
}
